"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LaundryOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25.75 2H6.25A3.13 3.13 0 003 5v23a2.15 2.15 0 002 2h22a2.15 2.15 0 002-2V5a3.13 3.13 0 00-3.25-3zM27 28H5V5a1.16 1.16 0 011.25-1h19.5A1.16 1.16 0 0127 5z"/><path d="M16 9a9 9 0 00-9 9 9.29 9.29 0 00.13 1.5v.05a9 9 0 0017.71-.07.15.15 0 000-.05A8.57 8.57 0 0025 18a9 9 0 00-9-9zm0 16a7 7 0 01-6.71-5A3.73 3.73 0 0112 19a7.09 7.09 0 013.49 1.36A8.74 8.74 0 0020 22a6.76 6.76 0 001.91-.27A7 7 0 0116 25zm7-6.23A3.63 3.63 0 0120 20a7.09 7.09 0 01-3.49-1.36A8.74 8.74 0 0012 17a6.07 6.07 0 00-3 .72A7 7 0 0123 18v.77zM8 8h4a1 1 0 000-2H8a1 1 0 000 2z"/>';
var LaundryOutlineSVG = function LaundryOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LaundryOutlineSVG = LaundryOutlineSVG;
LaundryOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LaundryOutlineSVG);
exports.default = _default;